import { periodFields } from './Period';

export const PeriodPlanResultFields = `
  id
  period{
    ${periodFields}
  }
  checklist
  alerts
  name
  targetHourLyCustomers
  actualHourLyCustomers
  targetWeeklyGp
  actualWeeklyGp
  targetWeeklyUpt
  actualWeeklyUpt
  targetWagePercent
  actualWagePercent
  plan
  managerFeedback {
    commenter
    body
    date
  }
  createdAt
  updatedAt
`;
